import animation from '@helpers/animation';
import { useInView } from '@hooks/useInView';
import { ReactComponent as SvgLogo } from '@img/logos/footer-logo.svg';
import { ReactComponent as SvgRemLogo } from '@img/logos/footer-rem-logo.svg';
import BackToTop from '@stories/Components/Footer/BackToTop/BackToTop';
import ContactDetails from '@stories/Components/Footer/ContactDetails/ContactDetails';
import FooterLinks from '@stories/Components/Footer/FooterLinks/FooterLinks';
import LegalLinks from '@stories/Components/Footer/LegalLinks/LegalLinks';
import SocialLinks from '@stories/Components/Footer/SocialLinks/SocialLinks';
import SiteWide from '@stories/Components/Global/SiteWide/SiteWide';
import React from 'react';
import S from './Footer.styles';
const Footer = ({ contactDetails, footerLinks, legalLinks, legalStatement, socialLinks, }) => {
    const [refContainer, isInView] = useInView({
        threshold: animation.inView.threshold,
    });
    return (React.createElement(S.Container, { ref: refContainer, isActive: isInView, flush: "both", fullWidth: true, themeOption: "light" },
        React.createElement(S.TopSection, null,
            React.createElement(SiteWide, null,
                React.createElement(S.LogoWrapper, null,
                    React.createElement(S.LogoLink, { href: "/", "aria-label": "The Shard" },
                        React.createElement(S.Logo, { as: SvgLogo }))),
                React.createElement(BackToTop, null),
                contactDetails && React.createElement(ContactDetails, { ...contactDetails }),
                footerLinks.map((footerLinkList) => (React.createElement(FooterLinks, { key: footerLinkList.id, ...footerLinkList }))),
                socialLinks && React.createElement(SocialLinks, { ...socialLinks }))),
        React.createElement(S.BottomSection, null,
            React.createElement(SiteWide, null,
                React.createElement("hr", null),
                React.createElement(S.BottomSectionInner, null,
                    legalLinks && React.createElement(LegalLinks, { ...legalLinks }),
                    legalStatement && (React.createElement(S.LegalStatementWrapper, null,
                        React.createElement(S.LegalLogo, { as: SvgRemLogo }),
                        React.createElement(S.LegalStatement, { dangerouslySetInnerHTML: { __html: legalStatement } }))))))));
};
export default Footer;
